// extracted by mini-css-extract-plugin
export var createdDate = "_mp-1";
export var divider = "_mp-2";
export var headerDivider = "_mp-3";
export var messagesCard = "_mp-0";
export var messagesContainer = "_mp-7";
export var messagesContainerWrapper = "_mp-4";
export var pointerCapturingButtonBoxes = "_mp-a";
export var showLeftPanelButton = "_mp-9";
export var showMoreButton = "_mp-c";
export var showMoreButtonContainer = "_mp-b";
export var summaryTitle = "_mp-6";
export var systemMessageCardWrapper = "_mp-d";
export var topButtons = "_mp-8";
export var withPadding = "_mp-5";